export default {
    slug: 'forms',
    ability: 'forms',
    routes: [
        {
            path: 'forms',
            name: 'form-list',
            component: () => import('@modules/Forms/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'form-preview',
                    component: () => import('@modules/Forms/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'form-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/forms/:id(\\d+)',
                            name: 'form-overview',
                            component: () => import('@modules/Forms/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'submissions',
                            name: 'form-submissions',
                            component: () => import('@modules/Forms/Resources/js/pages/preview/Submissions.vue'),
                            props: true
                        },
                        {
                            path: 'webhooks',
                            name: 'form-webhooks',
                            component: () => import('@modules/Forms/Resources/js/pages/preview/Webhooks.vue'),
                            props: true
                        },
                        {
                            path: 'analytics',
                            name: 'form-analytics',
                            component: () => import('@modules/Forms/Resources/js/pages/preview/Analytics.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'form-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'form-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        // Form Builder (full page)
        {
            path: 'forms/new',
            name: 'form-new',
            component: () => import('@modules/Forms/Resources/js/pages/Builder.vue')
        },
        {
            path: 'forms/:id(\\d+)/edit',
            name: 'form-edit',
            component: () => import('@modules/Forms/Resources/js/pages/Builder.vue'),
            props: route => ({ id: route.params.id })
        },
        // Form Templates
        {
            path: 'form-templates',
            name: 'form-template-list',
            component: () => import('@modules/Forms/Resources/js/pages/FormTemplates.vue')
        },
        {
            path: 'form-templates/:id(\\d+)/edit',
            name: 'form-template-edit',
            component: () => import('@modules/Forms/Resources/js/pages/Builder.vue'),
            props: route => ({ formTemplateId: route.params.id })
        }
    ],
    nav: () => ({
        section: 'marketing',
        items: [
            {
                title: i18n.t('Forms'),
                icon: 'form-select',
                to: { name: 'form-list' }
            }
        ]
    })
};
